import { Field, Form, Formik, ErrorMessage } from 'formik';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Button, Row } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { getAllStateByRegionId, getDiscomByStateId, registartionRequest } from "../../../store/Registartion/actions";
import { useSelector, useDispatch } from "react-redux";
import * as Yup from 'yup';
import moment from 'moment';
import consumerDetailsService from '../../../components/Services/consumerDetails.service';
import { toast } from 'react-toastify';
import { toastProperties } from '../../../commons/Toast/Toaster';
import { getCompanyList } from '../../../store/Login/actions';

const ConsumerDetails = ({ companyDetails, handleSecDetails, secDetails,handleAddRoleClose, getAllCompanyAdminUsers }) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state?.sessionState?.token);
  const discomTypes = useSelector(state => state?.registrationReducer?.discomTypes || []);
  const specificationTypes = useSelector(state => state?.registrationReducer?.specificationTypes || []);
  const allPointDrawl = useSelector(state => state.registrationReducer?.allPointDrawl || []);
  const regionTypes = useSelector(state => state?.registrationReducer?.regionTypes || []);
  const stateOptions = useSelector(state => state?.registrationReducer?.stateOptions || []);
  const discomOptions = useSelector(state => state?.registrationReducer?.discomOptions || []);
  const searchParams = new URLSearchParams(document.location.search);
  let tab = searchParams.get("tab");
  const formRef = useRef(null);
  const initialValues = {
    maxCapDrawl: '',
    // voltageLevelId: '',
    podId: '',
    specId: '',
    discomId: '',
    filteredVoltageLevels: '',
    discomVoltageId: '',
    specOther: '',
    regionId: '',
    stateUtId: '',
  }

  const handleStateChange = (id) => {
    getDiscomByStateId(id,dispatch)
  }

  const submitData = (isValid, dirty, values) => {
    if (isValid && dirty) {
      handleSecDetails(values);
    }
    else if (!isValid) {
      setTimeout(() => {
        handleSecDetails('')
      }, 0);
    }
  }

  const validationSchema = Yup.object().shape({
    regionId: Yup.string().required("Region Required"),
    stateUtId: Yup.string().required("State Required"),
    discomId: Yup.string().required("Discom Required"),
    discomVoltageId: Yup.string().required("Discom voltage Required"),
    maxCapDrawl: Yup.number()
    .test(
      'valueRange',
      'Value must be between 0 and 10,000 with 3 decimal places',
      (value) => {
        if (value === undefined || value === null) {
          return true;
        }
        const decimal = String(value).split('.')[1];
        return value >= 0 && value <= 10000 && (decimal?.length <= 3 || !decimal);
      }
    )
    .required('Required Field'),
  });

  const createConsumer = (reqBody)=>{
    consumerDetailsService.createConsumer(reqBody).then((response)=>{
      if(response?.data?.code === 200){
        handleAddRoleClose();
        getAllCompanyAdminUsers && getAllCompanyAdminUsers();
        toast.success(response?.data?.message,toastProperties);
      }
    }).catch(err=>console.log("Api call Error: ",err));
  }

  const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur()

    // Prevent the page/container scrolling
    e.stopPropagation()

    // Refocus immediately, on the next tick (after the current function is done)
    setTimeout(() => {
      e.target.focus()
    }, 0)
  }

  return (
    <Formik
      initialValues={secDetails || initialValues}
      validationSchema={validationSchema}
      innerRef={formRef}
      onSubmit={(values) => {
        let reqBodyConsumer = {
          "maxCapDrawl": +(values.maxCapDrawl),
          "podId": values.podId,
          "specId": +(values.specId),
          "discomId": values.discomId,
          "discomVoltage": values.discomVoltageId,
          "stateUtId": values.stateUtId,
          "regionId": values.regionId,
        }
        let reqData = {
          "holdingCompanyId": +(companyDetails?.holdingCompany),
          "user": {
            "userName": companyDetails?.userName,
            "email": companyDetails?.email,
            "password": companyDetails?.password,
            "phone": String(companyDetails?.phone),
            "roles": ["CONSUMER"],
          },
          "company": {
            "name": companyDetails?.name,
            "displayName": companyDetails?.displayName,
            "description": companyDetails?.description,
            "discomId": (companyDetails?.companyDiscomId),
            // "logo": companyDetails?.logo,
            "categoryId": +(companyDetails?.categoryId),
            "registeredAt": companyDetails?.registeredAt ? moment(companyDetails?.registeredAt).format("DD-MMM-YYYY") : companyDetails?.registeredAt,
            "pan": companyDetails?.pan,
            "tan": companyDetails?.tan,
            "gst": companyDetails?.gst,
            "documentIds": [
              companyDetails?.PAYMENT?.id,
              companyDetails?.MOA?.id,
              companyDetails?.PAN?.id,
              companyDetails?.logo !== "" ? companyDetails?.logo : undefined
            ].filter(Boolean),
            "bankAccounts": [
              {
                "nameAddress": companyDetails?.nameAddress,
                "accNo": companyDetails?.accNo,
                "ifsc": companyDetails?.ifsc,
                "operationalAt": companyDetails?.operationalAt ? moment(companyDetails?.operationalAt).format("DD-MMM-YYYY") : companyDetails?.operationalAt
              }
            ],
            "addresses": [
              {
                "type": "OFFICE",
                "address": companyDetails?.address,
                "cityId": parseInt(companyDetails?.cityId),
                "stateUtId": parseInt(companyDetails?.stateAndUtId),
                "pin": companyDetails?.pin,
                "tel": String(companyDetails?.tel),
                "email": companyDetails?.officeEmail,
                "fax": companyDetails?.fax?String(companyDetails?.fax) :null,
                "contactPersons": companyDetails?.contactPersons || [],
                "mob": String(companyDetails?.mob)
              },
              {
                "type": "CORRESPONDENCE",
                "address": companyDetails?.correspondenceAddress,
                "cityId": parseInt(companyDetails?.correspondenceCity),
                "stateUtId": parseInt(companyDetails?.correspondenceState),
                "pin": companyDetails?.correspondencePinCode,
                "tel": String(companyDetails?.correspondenceTelephone),
                "email": companyDetails?.correspondenceEmail,
                "fax": companyDetails?.correspondenceFaxNo ? String(companyDetails?.correspondenceFaxNo) : null,
                "contactPersons": companyDetails?.correspondenceContactPerson || [],
                "mob": String(companyDetails?.correspondenceMobileNo)
              }
            ],
            "creditRatingId": parseInt(companyDetails?.creditRatingId),
            "creditRatingYear": companyDetails?.creditRatingYear ? moment(companyDetails?.creditRatingYear).format("MMM-YYYY") : companyDetails?.creditRatingYear,
            "creditRatingAgency": companyDetails?.creditRatingAgency,
            "consumer": reqBodyConsumer,
            "isAcceptedByLaws":companyDetails?.confirmCheckbox,
            "isAcceptedBusinessRule":companyDetails?.acceptCheckBox,
          }
        }
        tab ? registartionRequest(reqData, dispatch) : createConsumer(reqBodyConsumer);
      }}
      
    >
      {({ values,isValid,errors, dirty, setFieldValue, setFieldTouched, setValues }) => {
       handleSecDetails && submitData(isValid, dirty, values);
       console.log("Consumer_details_formValue==>",{values,errors})
        return <Form>
        <h6>Consumer Details</h6>
          <Row className="justify-content-center align-items-center mb-4">
            <div className="col-md-6">
        <label htmlFor="maxCapDrawl">Maximum Capacity of Drawal*</label>
              <Field className="form-control custom-input" type="number" onWheel={numberInputOnWheelPreventChange} name="maxCapDrawl" />
              <ErrorMessage name='maxCapDrawl' className='text-danger' component='div' />
            </div>
            <div className="col-md-6">
            <label htmlFor="podId">Point Of Drawal</label>
              <Field as="select" className={`custom-input ${values.podId ? '' : 'custom-input-color'} w-100`} name="podId" onChange={(e) => setFieldValue("podId", e.target.value)}>
                <option value=""> Select Point Of Drawal</option>
                {allPointDrawl.map(item => <option key={item?.id} value={item?.id}>{item?.value}</option>)}
              </Field>
            </div>
          </Row>
          <Row className="justify-content-center align-items-center mb-4">
            <div className="col-md-6">
            <label htmlFor="specId">Consumer Specification</label>
              <Field as="select" className={`custom-input ${values.specId ? "" : "custom-input-color"} w-100`} name="specId" 
              onChange={(e) => {setFieldValue("specId", e.target.value);
                if (e.target.value !== "9") {
                  setFieldValue("specOther", "");
                }
              }}>
                <option value="">Select Consumer Specification</option>
                {specificationTypes?.CONSUMER?.map((item) => (
                  <option key={item?.id} value={item?.id}>
                    {item?.name}
                  </option>
                ))}
              </Field>
            </div>
            <div className="col-md-6">
            <label htmlFor="regionId">Region*</label>
              <Field as="select" className={`custom-input ${values.regionId ? '' : 'custom-input-color'} w-100`} name={"regionId"} onChange={(e) => {setFieldValue("regionId", e.target.value);getAllStateByRegionId(e.target.value,dispatch)}}>
                <option value="">Select Region*</option>
                {regionTypes.map(item => <option key={item?.id} value={item?.id}>{item?.name}</option>)}
              </Field>
              <ErrorMessage name='regionId' className='text-danger' component='div' />
            </div>
          </Row>
            <Row className="justify-content-center align-items-center mb-4">
            <div className="col-md-6">
            <label htmlFor="stateUtId">State*</label>
              <Field as="select" className={`custom-input ${values.stateUtId ? '' : 'custom-input-color'} w-100`} name={"stateUtId"} onChange={(e) => { setFieldValue("stateUtId", e.target.value); handleStateChange(e.target.value) }}>
                <option value="">Select State*</option>
                {stateOptions.map(item => <option key={item?.id} value={item?.id}>{item?.name}</option>)}
              </Field>
              <ErrorMessage name='stateUtId' className='text-danger' component='div' />
            </div>
            <div className='col-md-6'>
            <label htmlFor="discomId">Name of Discom*</label>
              <Field as="select" name={"discomId"} className={`custom-input ${values.discomId ? '' : 'custom-input-color'} w-100`} onChange={(e) => { setValues({ ...values, filteredVoltageLevels: discomTypes?.find(item => item.id == e.target.value)?.voltageLevels, discomId: e.target.value, discomVoltageId: '' }) }}>
                <option value="">Select Name of Discom</option>
                {discomOptions?.map((item) => (<option key={item?.id} value={item?.id}>{item?.acronym}</option>))}
              </Field>
              <ErrorMessage name='discomId' className='text-danger' component='div' />
            </div>
          </Row>
          <Row>
            <div className='col-md-6'>
            <label htmlFor="discomVoltageId">Voltage level*</label>
              <Field as="select" className={`custom-input ${values.discomVoltageId ? '' : 'custom-input-color'} w-100`} name='discomVoltageId' onChange={(e) => setFieldValue("discomVoltageId", e.target.value)}>
                <option value="">Select Voltage level</option>
                {(values.filteredVoltageLevels || [])?.map((voltageItem, index) =>
                  <option key={index} value={voltageItem}>{voltageItem}</option>
                )}
              </Field>
              <ErrorMessage name='discomVoltageId' className='text-danger' component='div' />
            </div>
          </Row>
          <hr
            style={{ width: "100%", margin: "20px auto", marginBottom: "20px", }}
          />
          <Row className="mb-3">
            <div className="text-center mt-4 fw-bold">
              <Button className="btn btn-lg btn-signup py-3 px-4" type='submit'>
                Submit & Sign up
              </Button>
            </div>
          </Row>
        </Form>
      }}
    </Formik>
  );
}

export default React.memo(ConsumerDetails);
